// Images
import athlete from "./img/athlete-small.png";
import athlete2 from "./img/athlete2.png";
import theracer from "./img/theracer-small.png";
import theracer2 from "./img/theracer-small.png";
import goodtimes from "./img/goodtimes-small.png";
import goodtimes2 from "./img/goodtimes-small.png";

export const MovieState = () => {
  return [
    {
      title: "The Athlete",
      mainImg: athlete,
      secondaryImg: athlete2,
      url: "/work/the-athlete",
      awards: [
        {
          title: "Truly A Materpiece",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "Fresh Look On A Brutal Sport.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "It's An OK Lamo.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
      ],
    },
    {
      title: "Good Times",
      mainImg: goodtimes,
      secondaryImg: goodtimes2,
      url: "/work/good-times",
      awards: [
        {
          title: "Truly A Materpiece",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "Fresh Look On A Brutal Sport.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "It's An OK Lamo.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
      ],
    },
    {
      title: "The Racer",
      mainImg: theracer,
      secondaryImg: theracer2,
      url: "/work/theracer",
      awards: [
        {
          title: "Truly A Materpiece",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "Fresh Look On A Brutal Sport.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
        {
          title: "It's An OK Lamo.",
          description:
            " Lorem, ipsum dolor sit amet consectetur adipisicing elit. Similique sit amet consectetur adipisicing elit.",
        },
      ],
    },
  ];
};
